<template>
<div>
    <b-modal id="matterEvidenceDetectionFormModal" ref="matterEvidenceDetectionFormModal" centered size="customize" no-close-on-backdrop :title= "$t('matter.matter_evidence_detection')" :cancel-title=" $t('others.cancel_title')" :ok-title=" $t('others.ok_title')" cancel-variant="outline-secondary" @ok.prevent="addOrUpdate()">
     <b-card>
                <b-row>
                    <b-col class="col-lg-4">
                        <b-form>
                            <label for="matter-evidence-detection-case-number-input">{{ $t('matterEvidenceDetection.case_number') }}</label>
                            <b-form-group>
                                <b-form-input size="sm" id="matter-evidence-detection-case-number-input" v-model="caseNumber" maxlength="50" />
                            </b-form-group>
                        </b-form>
                    </b-col>
                    <b-col class="col-lg-4">
                        <b-form>
                            <label for="matter-evidence-detection-court-input">{{ $t('matterEvidenceDetection.court') }}</label>
                            <b-form-group>
                                <b-form-select id="matter-evidence-detection-court-input" size="sm" v-model="courtSelect" value-field="id" text-field="name" :options="courtOption" />
                            </b-form-group>
                        </b-form>
                    </b-col>
                    <b-col class="col-lg-4">
                        <b-form>
                            <label for="matter-evidence-detection-subject-input">{{ $t('matterEvidenceDetection.subject') }}</label>
                            <b-form-group>
                                <b-form-select id="matter-evidence-detection-subject-input" size="sm" v-model="lawMatterSubjectSelect" value-field="id" text-field="name" :options="lawMatterSubjectOption" />
                            </b-form-group>
                        </b-form>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col class="col-lg-4">
                        <b-form>
                            <label for="matter-evidence-detection-product-category-input">{{ $t('matterEvidenceDetection.product_category') }}</label>
                            <b-form-group>
                                <b-form-select id="matter-evidence-detection-product-category-input" size="sm" v-model="lawProductCategorySelect" value-field="id" text-field="name" :options="lawProductCategoryOption" />
                            </b-form-group>
                        </b-form>
                    </b-col>
                    <b-col class="col-lg-4">
                        <b-form>
                            <label for="matter-evidence-detection-goods-input">{{ $t('matterEvidenceDetection.goods') }}</label>
                            <b-form-group>
                                <b-form-textarea id="matter-evidence-detection-goods-input" :placeholder=" $t('matterEvidenceDetection.goods')" v-model="goods" rows="2" />
                            </b-form-group>
                        </b-form>
                    </b-col>
                    <b-col class="col-lg-4">
                        <b-form>
                            <label for="matter-evidence-detection-goodsQuantity-input">{{ $t('matterEvidenceDetection.quantity') }}</label>
                            <b-form-group>
                                <b-form-input size="sm" id="matter-evidence-detection-goodsQuantity-input" v-model="goodsQuantity" type="number" maxlength="50" />
                            </b-form-group>
                        </b-form>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col class="col-lg-4">
                        <b-form>
                            <label for="matter-evidence-detection-city-input">{{ $t('matterEvidenceDetection.city') }}</label>
                            <b-form-group>
                                <b-form-select id="matter-evidence-detection-city-input" size="sm" v-model="citySelect" value-field="id" text-field="name" :options="cityOption" @change="getDistrictList()" />
                            </b-form-group>
                        </b-form>
                    </b-col>
                    <b-col class="col-lg-4">
                        <b-form>
                            <label for="matter-evidence-detection-state-input">{{ $t('matterEvidenceDetection.state') }}</label>
                            <b-form-group>
                                <b-form-select id="matter-evidence-detection-state-input" size="sm" v-model="districtSelect" value-field="id" text-field="name" :options="districtOption" />
                            </b-form-group>
                        </b-form>
                    </b-col>
                     <b-col class="col-lg-4">
                        <b-form>
                            <label for="matter-evidence-detection-type-input">{{ $t('matterEvidenceDetection.type') }}</label>
                            <b-form-group>
                                <b-form-select id="matter-evidence-detection-type-input" size="sm" v-model="lawEvidenceDetectionTypeSelect" value-field="id" text-field="name" :options="lawEvidenceDetectionTypeOption" />
                            </b-form-group>
                        </b-form>
                    </b-col>
                    
                </b-row>
                <b-row>
                    <b-col class="col-lg-4">
                        <b-form>
                            <label for="matter-evidence-detection-filed-on-date-input">{{ $t('matterEvidenceDetection.filed_on_date') }}</label>
                            <b-form-group>
                                <b-form-datepicker today-button :label-today-button="$t('dateTime.today')" size="sm" v-model="filedOnDate" class="mb1" defaultDate: null reset-button :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }" :locale="$i18n.locale" :label-reset-button="$t('dateTime.reset')" :label-no-date-selected="$t('dateTime.select_date')" />
                            </b-form-group>
                        </b-form>
                    </b-col>
                    <b-col class="col-lg-4">
                        <b-form>
                            <label for="matter-evidence-detection-conducted-on-date-input">{{ $t('matterEvidenceDetection.conducted_on_date') }}</label>
                            <b-form-group>
                                <b-form-datepicker today-button :label-today-button="$t('dateTime.today')" size="sm" v-model="conductedOnDate" class="mb1" defaultDate: null reset-button :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }" :locale="$i18n.locale" :label-reset-button="$t('dateTime.reset')" :label-no-date-selected="$t('dateTime.select_date')" />
                            </b-form-group>
                        </b-form>
                    </b-col>
                     <b-col class="col-lg-4">
                        <b-form>
                            <label for="matter-evidence-detection-report-received-date-input">{{ $t('matterEvidenceDetection.report_received_date') }}</label>
                            <b-form-group>
                                <b-form-datepicker today-button :label-today-button="$t('dateTime.today')"  size="sm" v-model="reportReceivedDate" class="mb1" defaultDate: null reset-button :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }" :locale="$i18n.locale" :label-reset-button="$t('dateTime.reset')" :label-no-date-selected="$t('dateTime.select_date')" />
                            </b-form-group>
                        </b-form>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col class="col-lg-4">
                        <b-form>
                            <label for="matter-evidence-detection-law-expert-opinion-outcome-input">{{ $t('matterEvidenceDetection.law_expert_opinion-outcome') }}</label>
                            <b-form-group>
                                <b-form-select id="matter-evidence-detection-law-expert-opinion-outcome-input" size="sm" v-model="lawExpertOpinionOutcomeSelect" value-field="id" text-field="name" :options="lawExpertOpinionOutcomeOption" />
                            </b-form-group>
                        </b-form>
                    </b-col>
                    <b-col class="col-lg-4">
                        <b-form>
                            <label for="matter-evidence-detection-objection-filed-on-date-input">{{ $t('matterEvidenceDetection.objection_filed_on_date') }}</label>
                            <b-form-group>
                                <b-form-datepicker today-button :label-today-button="$t('dateTime.today')"  size="sm" v-model="objectionFiledOnDate" class="mb1" defaultDate: null reset-button :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }" :locale="$i18n.locale" :label-reset-button="$t('dateTime.reset')" :label-no-date-selected="$t('dateTime.select_date')" />
                            </b-form-group>
                        </b-form>
                    </b-col>
                     <b-col class="col-lg-4">
                        <b-form>
                            <label for="matter-evidence-detection-objection-filed-on-date-input">{{ $t('matterEvidenceDetection.opponent_objection_date') }}</label>
                            <b-form-group>
                                <b-form-datepicker today-button :label-today-button="$t('dateTime.today')" size="sm" v-model="opponentObjectionDate" class="mb1" defaultDate: null reset-button :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }" :locale="$i18n.locale" :label-reset-button="$t('dateTime.reset')" :label-no-date-selected="$t('dateTime.select_date')" />
                            </b-form-group>
                        </b-form>
                    </b-col>
                </b-row>
                <b-row>
                     <b-col class="col-lg-4">
                        <b-form>
                            <label>{{ $t('matter.process_result') }}</label>
                            <b-form-select size="sm" v-model="lawMatterProcessResultSelect" value-field="id" text-field="name" :options="lawMatterProcessResultOption" />
                        </b-form>
                </b-col>
                </b-row>
            </b-card>
            <b-card :hidden="this.id == 0">
            <b-row>
                <b-col class="mt-2">
                    <b-tabs pills vertical nav-wrapper-class="nav-vertical">
                        <b-tab :title="$t('matterEvidenceDetection.counter_party')" style="width:100%;">
                            <b-card-text>
                                <law-matter-evidence-detection-counter-party-list :lawMatterEvidenceDetectionId="this.id"></law-matter-evidence-detection-counter-party-list>
                            </b-card-text>
                        </b-tab>
                    </b-tabs>
                </b-col>
            </b-row>
        </b-card>
            </b-modal>
</div>
</template>

  
<script>
export default {
    props: {
        getMatterTypeHistoryList: {
            type: Function
        },
        employeeId: {
            type: Number
        }
    },
    data() {
        return {
            id: 0,
            caseNumber: '',
            courtSelect: 0,
            courtOption: [],
            goodsQuantity: '',
            citySelect: 0,
            cityOption: [],
            districtSelect: 0,
            districtOption: [],
            lawEvidenceDetectionTypeSelect: 0,
            lawEvidenceDetectionTypeOption: [],
            lawMatterSubjectSelect: 0,
            lawMatterSubjectOption: [],
            lawProductCategorySelect: 0,
            lawProductCategoryOption: [],
            lawExpertOpinionOutcomeSelect: 0,
            lawExpertOpinionOutcomeOption: [],
            lawMatterProcessResultOption: [],
            lawMatterProcessResultSelect: 0,
            filedOnDate: null,
            conductedOnDate: null,
            reportReceivedDate: null,
            objectionFiledOnDate: null,
            opponentObjectionDate: null,
            lawMatterId: 0,
            goods: '',
            districtList: null
        }
    },
    methods: {
        showEvidenceDetection(id, lawMatterId) {
            this.$refs['matterEvidenceDetectionFormModal'].show()
            this.id = id
            this.lawMatterId = lawMatterId
            const data = {
                id: this.id
            }
            const controller = {
                name: 'LawMatterEvidenceDetection'
            }
            const payload = {
                data: data,
                controller: controller
            }
            this.$store.dispatch('moduleAuth/getInfo', payload).then((response) => {
                if (response.data.resultStatus == true) {
                    this.courtOption = response.data.lawAuthorityCourtList
                    if (this.courtOption != null) {
                        this.courtOption.splice(0, 0, this.$nullSelected())
                    }
                    this.cityOption = response.data.cityList
                    if (this.cityOption != null) {
                        this.cityOption.splice(0, 0, this.$nullSelected())
                    }
                    this.districtList = response.data.districtList

                    this.lawEvidenceDetectionTypeOption = response.data.lawEvidenceDetectionTypeList
                    if (this.lawEvidenceDetectionTypeOption != null) {
                        this.lawEvidenceDetectionTypeOption.splice(0, 0, this.$nullSelected())
                    }

                    this.lawMatterSubjectOption = response.data.lawMatterSubjectList
                    if (this.lawMatterSubjectOption != null) {
                        this.lawMatterSubjectOption.splice(0, 0, this.$nullSelected())
                    }
                    this.lawMatterSubjectSelect = response.data.lawMatterEvidenceDetection.lawMatterSubjectId

                    this.lawProductCategoryOption = response.data.lawProductCategoryList
                    if (this.lawProductCategoryOption != null) {
                        this.lawProductCategoryOption.splice(0, 0, this.$nullSelected())
                    }
                    this.lawProductCategorySelect = response.data.lawMatterEvidenceDetection.lawProductCategoryId

                    this.lawExpertOpinionOutcomeOption = response.data.lawExpertOpinionOutcomeList
                    if (this.lawExpertOpinionOutcomeOption != null) {
                        this.lawExpertOpinionOutcomeOption.splice(0, 0, this.$nullSelected())
                    }
                    this. lawExpertOpinionOutcomeSelect = response.data.lawMatterEvidenceDetection.lawExpertOpinionOutcomeId

                    this.opponentObjectionDate = response.data.lawMatterEvidenceDetection.opponentObjectionDate
                    this.caseNumber = response.data.lawMatterEvidenceDetection.caseNumber
                    this.courtSelect = response.data.lawMatterEvidenceDetection.lawAuthorityCourtId 
                    this.goodsQuantity = response.data.lawMatterEvidenceDetection.goodsQuantity
                    this.citySelect = response.data.lawMatterEvidenceDetection.cityId
                    this.lawEvidenceDetectionTypeSelect = response.data.lawMatterEvidenceDetection.lawEvidenceDetectionTypeId
                    this.filedOnDate = response.data.lawMatterEvidenceDetection.filedOnDate
                    this.conductedOnDate = response.data.lawMatterEvidenceDetection.conductedOnDate
                    this.reportReceivedDate = response.data.lawMatterEvidenceDetection.reportReceivedDate
                    this.objectionFiledOnDate = response.data.lawMatterEvidenceDetection.objectionFiledOnDate
                    this.goods = response.data.lawMatterEvidenceDetection.goods
                    if (response.data.lawMatterEvidenceDetection.cityId != 0) {
                        this.districtOption = this.districtList.filter(p => p.cityId == response.data.lawMatterEvidenceDetection.cityId)
                        this.districtSelect = response.data.lawMatterEvidenceDetection.districtId;
                        this.districtOption.splice(0, 0, this.$nullSelected())
                    }
                    this.lawMatterProcessResultOption = response.data.lawMatterProcessResultList
                    this.lawMatterProcessResultOption.splice(0, 0, this.$nullSelected())
                    this.lawMatterProcessResultSelect = response.data.lawMatterEvidenceDetection.lawMatterProcessResultId

                } else {                    
                    this.$bvModal.hide('matterEvidenceDetectionFormModal')
                    this.$WarningAlert(response.data.resultMessage)
                }
            })
           
            
        },
        async addOrUpdate() {
            const lawMatterEvidenceDetectionData = {
                            id: this.id,
                            lawMatterId: this.lawMatterId,
                            caseNumber: this.caseNumber,
                            lawAuthorityCourtId : this.courtSelect,
                            goodsQuantity: this.goodsQuantity,
                            cityId: this.citySelect,
                            districtId: this.districtSelect,
                            lawEvidenceDetectionTypeId: this.lawEvidenceDetectionTypeSelect,
                            filedOnDate: this.filedOnDate,
                            conductedOnDate: this.conductedOnDate,
                            reportReceivedDate: this.reportReceivedDate,
                            objectionFiledOnDate: this.objectionFiledOnDate,
                            goods: this.goods,
                            lawMatterSubjectId: this.lawMatterSubjectSelect,
                            lawProductCategoryId: this.lawProductCategorySelect,
                            lawExpertOpinionOutcomeId : this.lawExpertOpinionOutcomeSelect,
                            lawMatterProcessResultId :this.lawMatterProcessResultSelect,
                            opponentObjectionDate : this.opponentObjectionDate



                        }
            const controller = {
                name: 'LawMatterEvidenceDetection'
            }
            const payload = {
                data: lawMatterEvidenceDetectionData,
                controller: controller
            }
            var response = await this.$store.dispatch('moduleAuth/save', payload)
            if (response.data.resultStatus == true) {
                if(!this.id){
                    this.id = response.data.id
                    await this.$SaveLawMatterMatterTypeHistory(5, this.id, this.lawMatterId,this.employeeId) 
                    this.getMatterTypeHistoryList()
                }
                this.$SaveAlert()
            } else {
                this.$WarningAlert(response.data.resultMessage)
            }
        },
        getDistrictList() {
            if (this.citySelect > 0) {
                this.districtOption = this.districtList.filter(p => p.cityId == this.citySelect)
                this.districtSelect = 0;
                this.districtOption.splice(0, 0, this.$nullSelected())
            }
        }
    }
}
</script>
  
<style lang="scss">
[dir=ltr] .modal-header .close {
    margin: -0.4rem -0.4rem -0.8rem auto;
}

[dir] label {
    margin-bottom: 0.2857rem;
    font-weight: bold;
}

.modal .modal-content {
    overflow: visible;
    margin-bottom: auto;
}

[dir] .invalid-tooltip {
    padding: 0.4rem 0.775rem !important;
    margin-top: -1.5rem !important;
    background-color: #ea5455 !important;
    border-radius: 0.358rem !important;
    left: 20px !important
}
@media (min-width: 992px) { .modal .modal-customize { max-width: 60% !important; width: 60% !important;; } }

</style>
